import { CheckOutlined, CopyOutlined } from '@ant-design/icons';
import { Typography, message } from 'antd';
import { useState } from 'react';

type CopyReferrerLinkProps = {
    referrerCode: string | null;
    linkType: 'referrer' | 'service';
};

const CopyReferrerLink = ({
    referrerCode,
    linkType,
}: CopyReferrerLinkProps) => {
    const [copied, setCopied] = useState(false);

    const onClose = () => {
        setCopied(false);
    };

    const copyToClipboard = () => {
        if (!referrerCode && linkType === 'referrer') {
            message.error('Please select a smallcase Referrer', 1.3);
            return;
        }
        if (!copied) {
            linkType === 'referrer'
                ? navigator.clipboard.writeText(
                      `${window.location.origin}/apply/${referrerCode}`,
                  )
                : navigator.clipboard.writeText(
                      `${window.location.origin}/service`,
                  );

            setCopied(true);
            message.success('Link copied to clipboard', 2, onClose);
        }
    };

    return (
        <button
            type="button"
            aria-label={copied ? 'Referral link copied' : 'Copy referral link'}
            className={`cursor-pointer outline-none border-none bg-none p-0 ${
                copied ? 'text-gray-400' : ''
            }`}
            onClick={copyToClipboard}
            title={
                linkType === 'referrer'
                    ? 'This link is unique for each referrer code in the left-side dropdown. Client can login with their phone number to start or resume loan application'
                    : "This link is common for all clients to view their loan servicing dashboard. If you want to view the dashboard, search for client's loan from below list and click View dashboard button"
            }
        >
            <Typography.Text code>
                {linkType === 'referrer'
                    ? 'Share application link'
                    : 'Share dashboard link'}

                {copied ? (
                    <CheckOutlined className="ml-1 text-green-600" />
                ) : (
                    <CopyOutlined className="ml-1" />
                )}
            </Typography.Text>
        </button>
    );
};

export default CopyReferrerLink;
